

export default {
name: 'stylistAgreement',
components: {

},
data () {
return {

}
},
methods: {

},
created () {

},
mounted() {

},
}



// WEBPACK FOOTER //
// ./src/views/stylistAgreement/script.js